
export const CTAsSiNo = [
	{
		label: 'Sí',
		value: 'true'
	},
	{
		label: 'No',
		value: 'false'
	},
];
export const CTAsSiNoSinRespuesta = [
	{
		label: 'Sí',
		value: '1'
	},
	{
		label: 'No',
		value: '2'
	},
	{
		label: 'Sin respuesta',
		value: '9'
	},
];

export const CTAsContactoTurismos = [
	{
		label: 'Whatsapp',
		value: 'Whatsapp',
	},
	{
		label: 'Teléfono',
		value: 'Telefono',
	},
	{
		label: 'Email',
		value: 'Email',
	},
];

export const CTAsContactoComerciales = [
	{
		label: 'Teléfono',
		value: 'Telefono',
	},
	{
		label: 'Email',
		value: 'Email',
	},
];

export const CTAsHorario = [
	{
		label: 'Por la mañana',
		value: 'morning'
	},
	{
		label: 'Al mediodía',
		value: 'afternon'
	},
	{
		label: 'Por la tarde',
		value: 'evening'
	},
];
